import { type ThemeOptions } from '@mui/material';

export function createToggleButtonStyles() {
  return {
    MuiToggleButton: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-focusVisible': {
            '&::after': {
              borderRadius: `${theme.ui.focus.borderRadius}`,
              content: '""',
              inset: -1,
              outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
              outlineOffset: `${theme.ui.focus.outlineOffset}`,
              position: 'absolute',
              zIndex: 1, // Ensure the outline is above the button
            },
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
